<template>
  <div id="app">
    <div id="nav">
      <h6 v-if="isSignedIn" style="font-size: 13px;">ようこそ、{{user.email}}さん</h6>
      <div>
        <b-button v-if="isSignedIn" @click.prevent="signOut" variant="info">Signout</b-button>
        <div v-else>
          <router-link  to="/signup">SignUp</router-link> |
          <router-link  to="/signin">SignIn</router-link>
        </div>
      </div>
      <br>
      <template v-if="isSignedIn">
        <router-link to="/">Home</router-link> |
        <router-link to="/search">Search</router-link> |
        <router-link to="/list">List</router-link> |
        <router-link to="/ranking">Ranking</router-link> |
        <router-link to="/about">Create</router-link> |
        <router-link to="/myfavs">MyFavs</router-link> |
        <router-link to="/mylist">MyList</router-link>
      </template>
      <template v-else>
        <router-link to="/">Home</router-link> |
        <router-link to="/search">Search</router-link> |
        <router-link to="/ranking">Ranking</router-link> |
        <router-link to="/list">List</router-link> 
      </template>
    </div>
    <router-view/>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import "@firebase/auth"
export default {
  created() {
    firebase.auth().onAuthStateChanged(user => {
      user = user ? user : {}
      this.$store.commit('onAuthStateChanged', user)
      this.$store.commit('onAuthStatusChanged', user.uid ? true : false)
    }),
    
    this.$store.dispatch('getGoods')
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    isSignedIn() {
      return this.$store.getters.isSignedIn
    }
  },
  methods: {
    signOut() {
      firebase.auth().signOut()
      this.$router.push('/signin')
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: burlywood;
  padding-bottom: 10px;
  min-height: 100vh;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
